module.exports = __webpack_public_path__ + "img/logo.4b44d7be.png";